import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-e144c860',
  styleUrl: './md-e144c860.css',
  templateUrl: './md-e144c860.html',
})
export class MdE144c860 {
  readonly config = ENTITY_CONFIGS['e144c860'];
}
